const formatMoney = (money, currencyFormat = 'GBP', locale = 'en-GB') =>
  new Intl.NumberFormat(locale, { style: 'currency', currency: currencyFormat }).format(money);

export { formatMoney };
